import { render, staticRenderFns } from "./StateLand.vue?vue&type=template&id=2b3d6c2e&"
import script from "./StateLand.vue?vue&type=script&lang=ts&"
export * from "./StateLand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports